module.exports = __webpack_public_path__ + "static/media/1-2.5d36e8d6.png";